import request from "@/utils/request";

// 订单列表
export function orderList(data) {
  return request({
    url: "/order/order/wx/order/list",
    method: "get",
    params: data,
  });
}

// 订单详情
export function orderData(data) {
  return request({
    url: "/order/order/wx/order/info/" + data,
    method: "get",
  });
}

// 申请售后
export function addRefundOeder(data) {
  return request({
    url: "/order/order/refund/wx/add",
    method: "post",
    data: data,
  });
}

// 申请售后回调
export function addRefundOederAfter(data) {
  return request({
    url: "/order/order/refund/wx/callback/" + data,
    method: "get",
    // data: data,
  });
}

// 确认收货
export function verifyOeder(data) {
  return request({
    url: "/order/order/wx/confirm/receipt",
    method: "put",
    data: data,
  });
}

// 删除订单
export function deleteOeder(data) {
  return request({
    url: "/order/order/wx/order/delete/" + data,
    method: "DELETE",
    // data: data,
  });
}

// 商品评价
export function addEstimate(data) {
  return request({
    url: "/cc-mall/itemComment/insertItemComment",
    method: "post",
    data: data,
  });
}

// 售后详情
export function refundOederAfter(data) {
  return request({
    url: "/order/order/refund/wx/info/" + data,
    method: "get",
    // data: data,
  });
}

// 售后详情列表
export function refundOederAfterList(orderItemId, userId) {
  return request({
    url: "/order/order/refund/wx/list/" + orderItemId + "/" + userId,
    method: "get",
    // data: data,
  });
}

// 评价详情
export function estimateData(data) {
  return request({
    url: "/cc-mall/itemComment/commontDetail/" + data,
    method: "get",
    // data: data,
  });
}

// 下载版权
export function download(url) {
  return request({
    url: "/file/fileServer/dowload",
    method: "get",
    // responseType: "blob",
    params: url,
  });
}

// 查询版权图片
export function getdigitalCopyright(url) {
  return request({
    url: "/cc-mall/digitalCopyright/getCertificateAttachment/" + url,
    method: "get",
    // data: data,
    // params: url,
  });
}

// 查询下载地址
export function getDownload(url) {
  return request({
    url: "/painting/api/painting/downloadOriginalImage",
    method: "get",
    // responseType: "blob",
    params: url,
  });
}

// 商品评价
export function deleteApply(data) {
  return request({
    url: "/order/order/refund/wx/cancel",
    method: "put",
    data: data,
  });
}

// 收藏列表
export function collectList(data, params) {
  return request({
    url: "/cc-mall/collect/list",
    method: "post",
    params: params,
    data: data,
  });
}

// 我的购物车
export function shoppingList(data) {
  return request({
    url: "/cc-mall/cart/list",
    method: "get",
    params: data,
    // data: data,
  });
}

// 删除购物车商品
export function delShopping(data) {
  return request({
    url: "/cc-mall/cart/remove/batch?idxs=" + data,
    method: "delete",
    // params: data,
    // data: data,
  });
}

// 购物车结算
export function submitOrder(data) {
  return request({
    url: "/order/order/wx/cart/create/order",
    method: "post",
    // params: data,
    data: data,
  });
}

//我的地址列表
export function addressList(data) {
  return request({
    url: "/cc-mall/myAddress/list",
    method: "get",
    params: data,
    // data: data,
  });
}

//查询绘画列表
export function getDrawList(params) {
  return request({
    url: "/painting/api/painting/record",
    method: "get",
    params: params,
  });
}

//查询绘画信息
export function getDrawInfo(params) {
  return request({
    url: "/painting/api/painting/params",
    method: "get",
    params: params,
  });
}

//省
export function getProvince() {
  return request({
    url: "/cc-mall/province",
    method: "get",
    // params: params,
  });
}

//市
export function getCityData(params) {
  return request({
    url: "/cc-mall/city/" + params,
    method: "get",
    // params: params,
    // data: params,
  });
}

//区
export function getTownData(params) {
  return request({
    url: "/cc-mall/town/" + params,
    method: "get",
    // params: params,
  });
}

//新增地址
export function addAddress(data) {
  return request({
    url: "/cc-mall/myAddress/add",
    method: "post",
    // params: data,
    data: data,
  });
}

//修改地址
export function upDataAddress(data) {
  return request({
    url: "/cc-mall/myAddress/update",
    method: "put",
    // params: data,
    data: data,
  });
}

//删除地址
export function delAddress(data) {
  return request({
    url: "/cc-mall/myAddress/remove",
    method: "delete",
    params: data,
    // data: data,
  });
}

// 版权任务列表
export function assignmentList(data, params) {
  return request({
    url: "/cc-mall/copyrightOrder/list",
    method: "post",
    params: params,
    data: data,
  });
}

// 版权任务提交作品
export function upDataCopyrightOrder(data) {
  return request({
    url: "/cc-mall/copyrightOrder/update",
    method: "put",
    // params: params,
    data: data,
  });
}

// 驳回原因
export function rejectReasonData(data) {
  return request({
    url: "/flow/flow/queryRatifyHistoryList",
    method: "get",
    params: data,
    // data: data,
  });
}

// 我的版权登记列表
export function registerList(data) {
  return request({
    url: "/cc-mall/digitalCopyright/list",
    method: "get",
    params: data,
    // data: data,
  });
}

// 我的版权图片列表
export function getMyCopyrightPhotoList(data) {
  return request({
    url: "/cc-mall/digitalCopyright/listByUserId",
    method: "get",
    params: data,
    // data: data,
  });
}

// 我的版权图片详情
export function getMyCopyrightDetail(data) {
  return request({
    url: "/cc-mall/digitalCopyright/query/" + data,
    method: "get",
    // params: data,
    // data: data,
  });
}

// 我的版权图片申请上架
export function updigitalCopyright(data) {
  return request({
    url: "/cc-mall/digitalCopyright/grounding",
    method: "post",
    // params: data,
    data: data,
  });
}

// 下架
export function deldigitalCopyright(data) {
  return request({
    url: "/cc-mall/digitalProduct/switchState/" + data,
    method: "PUT",
    // params: data,
    // data: data,
  });
}

// 获取创作者信息
export function getCreatorData(data) {
  return request({
    url: "/creator/appCreator/info",
    method: "get",
    // params: data,
    // data: data,
  });
}

// 获取用户信息
export function getUserData(data) {
  return request({
    url: "/system/appUser/info",
    method: "get",
    // params: data,
    // data: data,
  });
}
